import { defaultAxios } from '@/services/index';

const kustomerService = {
  async createKustomerInfo(
    workspaceAlias: string,
    domain: string,
    access_token: string,
  ) {
    try {
      const res = await defaultAxios.post(
        `/workspaces/${workspaceAlias}/kustomer/credential`,
        { domain, access_token },
      );
      return res.data;
    } catch (e) {
      return false;
    }
  },

  async getKustomerInfo(alias: string) {
    try {
      const res = await defaultAxios.get(`/workspaces/${alias}/kustomer/`);
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async deleteKustomerInfo(alias: string) {
    try {
      const res = await defaultAxios.delete(`/kustomer/${alias}`);
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async importWorkspaceFeedback(
    alias: string,
    startDate: string,
    endDate: string,
  ) {
    try {
      const res = await defaultAxios.post(`/kustomer/${alias}/import`, {
        start_date: startDate,
        end_date: endDate,
      });
      return res.data;
    } catch (e) {
      return false;
    }
  },
};

export default kustomerService;
